import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { AppDispatch } from 'src/app/store';
import NavLanguage from 'src/components/NavLanguage/NavLanguage';
import FooterPublic from 'src/components/Footer/FooterPublic';
import { isAuthenticated } from 'src/features/Auth';
import { syncCompanyContext } from 'src/features/Auth/Auth.slice';

export interface Props {
  component: React.FC;
}

const PrivateLightRoute = ({ component: Component }: Props) => {
  const dispatch = useDispatch<AppDispatch>();
  const location = useLocation();
  const params = new URLSearchParams(location.search);

  useEffect(() => {
    dispatch(syncCompanyContext());
  }, [dispatch]);

  return isAuthenticated() ? (
    <>
      {/* Private route with public-page for the multi-company access flow. */}
      <NavLanguage />
      <Component />
      <FooterPublic />
    </>
  ) : (
    <Navigate to={`/auth/signin?${params.toString()}`} />
  );
};

export default PrivateLightRoute;
